module.exports = __webpack_public_path__ + "media/images/flags/eh-f5ee0a5e9a1dea8bc41a54ad5591eb5c.svg";